'use strict';

angular.module('AcaApp').factory('AuxiliaryDataService',
[
  '$rootScope',
  '$timeout',
  'AuxiliaryDataResource',
  'LrjResource',
  function($rootScope, $timeout, AuxiliaryDataResource, LrjResource){
    return{
      GetCountryList: function(){
        var rpcConfig = {method: 'GetCountryList', params: []};
        return AuxiliaryDataResource.executeRpc(rpcConfig).$promise;
      },
      getLrjStatusList: function(jobType){
        var rpcConfig = {method: 'GetLrjStatusList', params: [jobType]};
        return LrjResource.executeRpc(rpcConfig).$promise;
      },
      LoadCountryList: function(){
        if($rootScope.countries === undefined){
          this.GetCountryList().then(function(data){
            $timeout(function(){
              $rootScope.countries = data.result;
            }, 0);
          });
        }
      }
    };
  }
]);